module.exports = __webpack_public_path__ + "step5_parent_to_child.d6058588.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step5_parent_to_child.jpg
// module id = 891q
// module chunks = 0